module.exports = __webpack_public_path__ + "img/h6.02f84157.png";